import type React from 'react';
import { isProductionLikeEnvironment } from 'utils/environment/environment';

const IsProduction = ({ children }: { children: React.ReactNode }) => {
  return <>{isProductionLikeEnvironment() ? children : null}</>;
};

export { IsProduction };
